module.exports = __webpack_public_path__ + "img/4.20b3ce36.jpg";